export const roleCodes = {
  admin: 'admin',
  guest: 'guest',
  user: 'user',
}

export const roleIds = {
  1: 'owner',
  2: 'admin',
  3: 'member',
}

export const organizationPermissionCodes = {
  organizationManageEdit: 'edit',
  organizationManageMedal: 'organization_manage_medal',
  organizationManageEvent: 'organization_manage_event',
  organizationManageChannel: 'organization_manage_channel',
  organizationManageArticle: 'organization_manage_post',
  organizationManageMember: 'organization_manage_member',
  organizationManageInfo: 'organization_manage_settings',
  organizationManageDelete: 'organization_manage_delete',
  organizationManageRole: 'organization_manage_role',
  organizationManagePermission: 'organization_manage_permission',
  organizationManageStructure: 'organization_manage_structure',
  organizationManagePeerStructure: 'organization_manage_peer_structure',
  organizationManageGames: 'organization_manage_games',
}

export const permissionCodes = {
  canPost: 'can_post',
  canInvite: 'canInvite',
  canJoin: 'canJoin',
  canSubscribe: 'canSubscribe',
  canBookmark: 'canBookmark',
  canPostArticle: 'canPostArticle',
  canCopy_link: 'canCopy_link',
  canDelete: 'canDelete',
  canEdit: 'canEdit',
  canMessage: 'canMessage',
  canRemove: 'canRemove',
  canShare: 'canShare',
  canTo: 'canTo',
  canView: 'canView',
  canVote: 'canVote',
}
